export const LEXICAL_TEXT_THEME = {
  root: "lexical-root",
  paragraph: "mb-3 leading-relaxed text-base",
  heading: {
    h1: "text-4xl font-bold mb-4 mt-3 leading-tight",
    h2: "text-3xl font-bold mb-3 mt-2 leading-tight",
    h3: "text-2xl font-semibold mb-3 mt-2 leading-snug",
    h4: "text-xl font-semibold mb-2 mt-1.5 leading-snug",
    h5: "text-lg font-semibold mb-2 mt-1 leading-normal",
    h6: "text-base font-semibold mb-2 mt-1 leading-normal text-gray-600",
  },
  list: {
    ul: "list-disc ml-6 mb-3 text-base",
    ol: "list-decimal ml-6 mb-3 text-base",
    listitem: "mb-1.5",
  },
  quote: "border-l-4 border-gray-300 pl-4 italic text-gray-600 mb-3 text-base",
  text: {
    bold: "font-bold",
    italic: "italic",
    underline: "underline",
    strikethrough: "line-through",
  },
  link: "underline cursor-pointer",
};

// Variant for plain gray/white surfaces (memory drawer) where links need the
// standard blue treatment to read as clickable. Text blocks keep the inherited
// color: their themed cards (e.g. blue gradient with a light foreground) control
// contrast, and a hardcoded blue can be unreadable there.
export const LEXICAL_TEXT_THEME_ACCENT_LINKS = {
  ...LEXICAL_TEXT_THEME,
  link: "text-blue-600 underline cursor-pointer hover:text-blue-700",
};
